module.exports = __webpack_public_path__ + "img/Ranzen.bb07015b.svg";